export const WIDGET_PADDING = '30px';
